import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Api 回傳值
 */
export interface ContractConfirmViewDataResp extends GeneralResp {
    contractHtmlA: string | null;
    contractHtmlB: string | null;
}

/**
 * @todo 契約 Confirm ViewData
 */
const ContractConfirmViewData = (): Promise<ContractConfirmViewDataResp> => {
    const url = RouteUrlList.API_ContractConfirmViewData.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, {}, config).then((res: AxiosResponse<ContractConfirmViewDataResp>) => {
        return res.data;
    });
};

export default ContractConfirmViewData;
